export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-white">
      <h1 className="text-3xl font-bold text-blue-200 mb-4">Privacy Policy</h1>
      <p className="text-gray-300 mb-4">
        We respect your privacy. This site does not collect personal data from users. However, we may use third-party services such as Google AdSense, which may use cookies or similar tracking technologies to serve relevant ads based on your visit.
      </p>
      <p className="text-gray-300">
        By using this site, you consent to the use of such technologies. You may manage or disable cookies in your browser settings. For more details, please refer to Google's privacy policy.
      </p>
    </div>
  );
}
